import utils from "@/utils/utils";

const message = (options) => {
  return utils.messageBox(options);
};

const success = (msg) => message({
  type: "success",
  message: msg
})

const error = (msg) => message({
  type: "error",
  message: msg
})

export default {
  message,
  success,
  error,
};
